import { call, put, takeLatest, select } from 'redux-saga/effects';
import verificationQueryService from '../../../services/verificationQueryService';
import {
  fetchQueries,
  fetchQueriesSuccess,
  fetchQueriesFailure,
  fetchQueryById,
  fetchQueryByIdSuccess,
  fetchQueryByIdFailure,
  createQuery,
  createQuerySuccess,
  createQueryFailure,
  updateQuery,
  updateQuerySuccess,
  updateQueryFailure,
  deleteQuery,
  deleteQuerySuccess,
  deleteQueryFailure,
  fetchStatistics,
  fetchStatisticsSuccess,
  fetchStatisticsFailure,
//   fetchConfiguration,
//   fetchConfigurationSuccess,
//   fetchConfigurationFailure,
//   updateConfiguration,
//   updateConfigurationSuccess,
//   updateConfigurationFailure,
  selectQueriesPage,
  selectQueriesPageSize,
  selectQueriesSortColumn,
  selectQueriesSortDirection,
  selectFilterDeviceId,
  selectFilterUnitName,
  selectFilterQueryType,
  selectFilterStatus,
  selectFilterSecurityLevel,
  selectFilterStartDate,
  selectFilterEndDate,
} from './slice';

function* handleFetchQueries() {
  try {
    // Get current filter/pagination state
    const page = yield select(selectQueriesPage);
    const pageSize = yield select(selectQueriesPageSize);
    const sortColumn = yield select(selectQueriesSortColumn);
    const sortDirection = yield select(selectQueriesSortDirection);
    const deviceId = yield select(selectFilterDeviceId);
    const unitName = yield select(selectFilterUnitName);
    const queryType = yield select(selectFilterQueryType);
    const status = yield select(selectFilterStatus);
    const securityLevel = yield select(selectFilterSecurityLevel);
    const startDate = yield select(selectFilterStartDate);
    const endDate = yield select(selectFilterEndDate);

    const params = {
      page,
      pageSize,
      sortColumn,
      sortDirection,
      deviceId,
      unitName,
      queryType,
      status,
      securityLevel,
      startDate,
      endDate,
    };

    const response = yield call(verificationQueryService.getQueries, params);
    yield put(fetchQueriesSuccess(response));
  } catch (error) {
    yield put(fetchQueriesFailure(error.message));
  }
}

function* handleFetchQueryById(action) {
  try {
    const response = yield call(verificationQueryService.getQueryById, action.payload);
    yield put(fetchQueryByIdSuccess(response));
  } catch (error) {
    yield put(fetchQueryByIdFailure(error.message));
  }
}

function* handleCreateQuery(action) {
  try {
    const response = yield call(verificationQueryService.createQuery, action.payload);
    yield put(createQuerySuccess(response));
    // Refresh queries list
    yield put(fetchQueries());
  } catch (error) {
    yield put(createQueryFailure(error.message));
  }
}

function* handleUpdateQuery(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(verificationQueryService.updateQuery, id, data);
    yield put(updateQuerySuccess(response));
    // Refresh queries list
    yield put(fetchQueries());
  } catch (error) {
    yield put(updateQueryFailure(error.message));
  }
}

function* handleDeleteQuery(action) {
  try {
    const response = yield call(verificationQueryService.deleteQuery, action.payload);
    yield put(deleteQuerySuccess(response));
    // Refresh queries list
    yield put(fetchQueries());
  } catch (error) {
    yield put(deleteQueryFailure(error.message));
  }
}

function* handleFetchStatistics() {
  try {
    const response = yield call(verificationQueryService.getStatistics);
    yield put(fetchStatisticsSuccess(response));
  } catch (error) {
    yield put(fetchStatisticsFailure(error.message));
  }
}
// 
// function* handleFetchConfiguration() {
//   try {
//     const response = yield call(verificationQueryService.getConfiguration);
//     yield put(fetchConfigurationSuccess(response));
//   } catch (error) {
//     yield put(fetchConfigurationFailure(error.message || 'Failed to fetch configuration'));
//   }
// }
// 
// function* handleUpdateConfiguration(action) {
//   try {
//     const response = yield call(verificationQueryService.updateConfiguration, action.payload);
//     yield put(updateConfigurationSuccess(response));
//   } catch (error) {
//     yield put(updateConfigurationFailure(error.message || 'Failed to update configuration'));
//   }
// }

export function* watchVerificationQueriesActions() {
  yield takeLatest(fetchQueries.type, handleFetchQueries);
  yield takeLatest(fetchQueryById.type, handleFetchQueryById);
  yield takeLatest(createQuery.type, handleCreateQuery);
  yield takeLatest(updateQuery.type, handleUpdateQuery);
  yield takeLatest(deleteQuery.type, handleDeleteQuery);
  yield takeLatest(fetchStatistics.type, handleFetchStatistics);
//   yield takeLatest(fetchConfiguration.type, handleFetchConfiguration);
//   yield takeLatest(updateConfiguration.type, handleUpdateConfiguration);
}
